import { FAQJson } from "@/src/types/faq/faq.data";
import type { FAQItem } from "@/src/types/faq/faq.types";

export const getFaqsInOrder = (ids: readonly number[]): FAQItem[] =>
  ids
    .map((id) => FAQJson.data.find((item) => item.id === id))
    .filter((item): item is FAQItem => item !== undefined);
